<template>
  <div>
    <v-text-field
      label="Megnevezés"
      :error-messages="errors.name"
      v-model="gate.name"
      filled
      clearable />

    <v-text-field
      label="Megnevezés kiegészítés"
      :error-messages="errors.name_addition"
      v-model="gate.name_addition"
      filled />

    <v-card flat color="muted" class="px-4 mb-4 d-flex align-center">
      <v-switch
        label="Kiegészítő eszköz"
        class="py-2 my-2"
        hide-details
        v-model="gate.additional"
        inset />
    </v-card>

    <v-card flat color="muted" class="px-4 mb-4 d-flex align-center">
      <v-switch :error-messages="errors.opening_warning" v-model="gate.open_warning" inset>
        <template v-slot:label>
          <div>
            <div>Tartós nyitás figyelmeztetés</div>
            <div class="text-caption">
              Olyan záraknál beállítandó, ahol a hosszú nyitójel tönkreteheti azt
            </div>
          </div>
        </template>
      </v-switch>
    </v-card>

    <v-textarea
      label="Megjegyzés"
      :error-messages="errors.comment"
      v-model="gate.comment"
      :rows="3"
      filled
      auto-grow />
  </div>
</template>

<script>
// import { useVModels } from '@vueuse/core';

export default {
  props: {
    gate: {
      type: Object,
      default: () => ({}),
    },

    errors: {
      type: Object,
      default: () => ({}),
    },

    dense: {
      type: Boolean,
      default: false,
    },
  },

  // setup(props, { emit }) {
  //   const { gate } = useVModels(props, emit);

  //   // return {
  //   //   gate,
  //   // };
  // },
};
</script>